export default __webpack_public_path__ + "static/grouppic-c20717618e4571e6e275c2d4be148ae5.png";